
import { z } from "zod";

export const RoofMaterialValues = ["ASPHALT", "TILE"] as const;
export const RoofMaterialSchema = /* @__PURE__ */ z.enum(RoofMaterialValues);
export const RoofMaterial: (typeof RoofMaterialSchema)["enum"] = { "ASPHALT": "ASPHALT", "TILE": "TILE" };
export type RoofMaterial = (typeof RoofMaterialValues)[number];
